import { render, staticRenderFns } from "./FormGroupMultiselect.vue?vue&type=template&id=846f877c&"
import script from "./FormGroupMultiselect.vue?vue&type=script&lang=js&"
export * from "./FormGroupMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports